import React, { useRef, useState, useEffect } from 'react';
import "./editStatusForMobile.css"
import "./editStatusForMobileDark.css"
import axios from 'axios';
import { useToast } from '@chakra-ui/react'
import { useSelector } from 'react-redux';
import sockets from '../../../../../socket/socket';


const DropdownMobileStatus = ({ isChild, statusGet, allitemForStatus, index, update }) => {

    let getmyinfo = useSelector(compID => compID.getMayInfoReducer)
    const myinfos = useSelector(data => data.getMyImageReducer);
    const getDarkModoe = useSelector(darkModes => darkModes )
    const modalRed = useRef(null)
    const spanRef = useRef(null)
    const toast = useToast()
    const socket = sockets;
    var modal = document.getElementById("myModal");





// When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }

// When the user clicks anywhere outside of the modal, close it

const handleCloseModal=()=>{
    modalRed.current.style.display = "none"
}
const handleOpenModal=()=>{
    modalRed.current.style.display = "block"
}

const handleGetNotify = () => {
    socket.emit('getNotifyEmit');
}

const close=(e)=>{
       if (e.target.id == "myModal") {
        modalRed.current.style.display = "none"
       }
}
const handleUpdateStatus = (e) => {
    if (isChild) {

        allitemForStatus.alltask[0].child[index].status = e
        axios.post('/updateMyTaskForStatusAndPriritet/api', {
            allitemForStatus
        })
            .then(function (response) {
                console.log(response.data.message);
                update()
                toast({
                    position: "top",
                    title: response.data.message,
                    description: response.data.message,
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
                modalRed.current.style.display = "none"
               
            })
            .catch(function (error) {
                console.log(error);
                update()
                modalRed.current.style.display = "none"
            });

    } else {
        allitemForStatus.alltask[0].status = e
        axios.post('/updateMyTaskForStatusAndPriritet/api', {
            allitemForStatus
        })
            .then(function (response) {
                console.log(response);
                update()
                toast({
                    position: "top",
                    title: response.data.message,
                    description: response.data.message,
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
                modalRed.current.style.display = "none";
               
            })
            .catch(function (error) {
                console.log(error);
                update()
                modalRed.current.style.display = "none"
            });

    }

}

const handleStatus = () => {
    if (isChild) {
      // update Child
      axios.post('/notifyConfirm', {
          eidtTaskID: allitemForStatus._id,
          isChild: true,
          adminIDTask: allitemForStatus.creatorTasks.toString(),
          typenotify: "status",
          indexTask: index,
          senderName: getmyinfo.myinfo.name,
          senderTel: getmyinfo.myinfo.tel,
          senderEmail: getmyinfo.myinfo.email,
          text: "",
          messageConfirm: allitemForStatus.alltask[0].endDate,
          taskName: allitemForStatus.alltask[0].taskName,
          oldDate: allitemForStatus.alltask[0].endDate,
          myAvatar: myinfos.users.myavatar

      })
          .then(function (response) {

              handleGetNotify()
              toast({
                  position: "top",
                  title: 'Отправлено на подтверждение постановщику задачи',
                  description: "Отправлено на подтверждение постановщику задачи",
                  status: 'success',
                  duration: 9000,
                  isClosable: true,
              })
          })
          .catch(function (error) {
              console.log(error);
          });
    }else{
      // update parent
          axios.post('/notifyConfirm', {
      eidtTaskID: allitemForStatus._id,
      isChild: false,
      adminIDTask: allitemForStatus.creatorTasks.toString(),
      typenotify: "status",
      indexTask: 0,
      senderName: getmyinfo.myinfo.name,
      senderTel: getmyinfo.myinfo.tel,
      senderEmail: getmyinfo.myinfo.email,
      text: "",
      messageConfirm: allitemForStatus.alltask[0].endDate,
      taskName: allitemForStatus.alltask[0].taskName,
      oldDate: allitemForStatus.alltask[0].endDate,
      myAvatar: myinfos.users.myavatar

  })
      .then(function (response) {

          handleGetNotify()
          toast({
              position: "top",
              title: 'Отправлено на подтверждение постановщику задачи',
              description: "Отправлено на подтверждение постановщику задачи",
              status: 'success',
              duration: 9000,
              isClosable: true,
          })
      })
      .catch(function (error) {
          console.log(error);
      });
    }
  

}

// этот функция для того чтобы создать уведомление для задач
function sendSeverCreatNotifyForTask(e) {

    if (isChild) {
        let notifyText =`${getmyinfo.myinfo.name}  взял <a target="_blank" class="taskName" href="editChild/${allitemForStatus._id}/${index}">${allitemForStatus.alltask[0].child[index].taskName} </a> в работу.`
        axios.post('/creatNotifyForTaskInfo/api', {
            // здесь не проверяем Это задача и подзадача
            isChild,
            // здесь мы отправляем полное задание
            task:allitemForStatus,
            // если это подзадача тогда получаем индекс этого подзадачу
            index,
            // здесь мы отправляем текст для уведомлений
            notifyText,
            // кому нужно отправить этот уведомление мы берём идентификатор этого пользователя
            notificationRecipientID:allitemForStatus.creatorTasks,
               // информация пользователя для отправления уведомлений на электронную почту
            emailInfo:{
                // здесь мы отправляем идентификатор пользователя
                userIdForEmail:allitemForStatus.creatorTasks,
                // текст для заголовки
                subject:"Задача в работе",
                // текст для электронную почту
                textEmail:""
            }
        })
        .then(function (response) {
            console.log(response);
            socket.emit('getNotifyEmit');
        })
        .catch(function (error) {
            console.log(error);
        });
    }else{
        // для подзадач=================================================================================================================================================================================================
        let notifyText = `${getmyinfo.myinfo.name} взял  <a target="_blank" class="taskName" href="getCurrentTask/${allitemForStatus._id}">Задачу ${allitemForStatus.alltask[0].taskName} </a>  в работу.`
        axios.post('/creatNotifyForTaskInfo/api', {
            // здесь не проверяем Это задача и подзадача
            isChild,
            // здесь мы отправляем полное задание
            task:allitemForStatus,
            //  // если это подзадача тогда получаем индекс этого подзадачу
            index:1234,
             // здесь мы отправляем текст для уведомлений
            notifyText,
            // кому нужно отправить этот уведомление мы берём идентификатор этого пользователя
            notificationRecipientID:allitemForStatus.creatorTasks,
            // информация пользователя для отправления уведомлений на электронную почту
            emailInfo:{
                // здесь мы отправляем идентификатор пользователя
                userIdForEmail:allitemForStatus.creatorTasks,
                // текст для заголовки
                subject:"Задача в работе",
                // текст для электронную почту
                textEmail:""
            }
        })
        .then(function (response) {
            console.log(response);
            socket.emit('getNotifyEmit');
        })
        .catch(function (error) {
            console.log(error);
        });
    }
}

const handleStatusAndSendNotify=(e)=>{
    if (isChild) {

        allitemForStatus.alltask[0].child[index].status = e
        axios.post('/updateMyTaskForStatusAndPriritet/api', {
            allitemForStatus
        })
            .then(function (response) {
                    // send notify
                    sendSeverCreatNotifyForTask(e)  
               
                toast({
                    position: "top",
                    title: response.data.message,
                    description: response.data.message,
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                });
                update();
               
            })
            .catch(function (error) {
                update();
            });

    } else {
        allitemForStatus.alltask[0].status = e
        axios.post('/updateMyTaskForStatusAndPriritet/api', {
            allitemForStatus
        })
            .then(function (response) {
                sendSeverCreatNotifyForTask(e)  
                update()
                toast({
                    position: "top",
                    title: response.data.message,
                    description: response.data.message,
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
               
            })
            .catch(function (error) {
                console.log(error);
                update()
            });

    }
}
    return (
        <div className= {getDarkModoe.ToggleDarkModeReducer.chekced?"editStatusMobileDark":"editStatusMobile"}>
          
                <div className='showStatus'>
                {(() => {
                    if (statusGet == "Принята") {
                        return (
                            <div onClick={handleOpenModal}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                <circle cx="13" cy="13" r="12.5" fill="#84FF70" />
                                <rect x="6.97363" y="11.2776" width="8.80282" height="2.46479" transform="rotate(45 6.97363 11.2776)" fill="white" />
                                <path d="M21.0254 9.6748L11.4558 19.2444L9.71289 17.5015L19.2825 7.93194L21.0254 9.6748Z" fill="white" />
                                 </svg>
                                 <p>Принята</p>
                            </div>
                        )
                    } else if (statusGet == "Отменено") {
                        return (
                            <div onClick={handleOpenModal}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <path d="M12.5 0C5.59375 0 0 5.59375 0 12.5C0 19.4062 5.59375 25 12.5 25C19.4062 25 25 19.4062 25 12.5C25 5.59375 19.4062 0 12.5 0ZM19.1458 17.3125L17.3021 19.1562L12.5 14.3438L7.6875 19.1562L5.84375 17.3125L10.6562 12.5L5.85417 7.6875L7.69792 5.84375L12.5 10.6562L17.3125 5.84375L19.1562 7.6875L14.3438 12.5L19.1458 17.3125Z" fill="#FF7070" />
                                    </svg>
                                    <p>Отменено</p>
                            </div>
                        )
                    } else if (statusGet == "Выполняется") {
                        return (
                            <div onClick={handleOpenModal}>
                                 <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4035 25 25 19.4035 25 12.5C25 5.59644 19.4035 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4035 5.59644 25 12.5 25Z" fill="#707EFF" />
                                <path d="M16.7671 13.8238L10.8669 17.3073C9.91714 17.868 8.75 17.1381 8.75 15.9835V9.01645C8.75 7.86184 9.91714 7.13201 10.8669 7.69274L16.7671 11.1763C17.7443 11.7533 17.7443 13.2467 16.7671 13.8238Z" fill="white" />
                            </svg>
                            <p>Выполняется</p>
                            </div>
                        )
                    }
                    else if (statusGet == "Выполнена") {
                        return (
                            <div onClick={handleOpenModal}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <g clip-path="url(#clip0_1274_4128)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4035 25 25 19.4035 25 12.5C25 5.59644 19.4035 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4035 5.59644 25 12.5 25Z" fill="#70DDFF" />
                                    <path d="M17.8495 8.53731C15.2966 6.69708 12.7441 10.276 10.1911 9.0313V8.76653C10.1911 8.43769 9.92435 8.17091 9.59554 8.17091C9.26674 8.17091 9 8.43769 9 8.76653V19.0186C9 19.3473 9.26674 19.6141 9.59554 19.6141C9.92435 19.6141 10.1911 19.3473 10.1911 19.0186V14.6754C12.6176 15.858 15.0442 12.6835 17.4711 13.9468C17.5262 13.9757 17.5878 13.9898 17.65 13.9879C17.7121 13.9859 17.7727 13.9679 17.8259 13.9355C17.8791 13.9033 17.9231 13.8579 17.9536 13.8037C17.9841 13.7495 18.0001 13.6883 18 13.6261V8.83085C17.9999 8.77351 17.9862 8.71702 17.96 8.66599C17.9339 8.61497 17.896 8.57087 17.8495 8.53731Z" fill="white" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1274_4128">
                                        <rect width="25" height="25" fill="white" />
                                    </clipPath>
                                </defs>
                                   </svg>
                                   <p>Выполнена</p>
                            </div>
                        )
                    }
                    else if (statusGet == "Запланирована") {
                        return (
                            <div onClick={handleOpenModal}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C15.8152 25 18.9946 23.683 21.3388 21.3388C23.683 18.9946 25 15.8152 25 12.5C25 9.18479 23.683 6.00537 21.3388 3.66116C18.9946 1.31696 15.8152 0 12.5 0C9.18479 0 6.00537 1.31696 3.66116 3.66116C1.31696 6.00537 0 9.18479 0 12.5C0 15.8152 1.31696 18.9946 3.66116 21.3388C6.00537 23.683 9.18479 25 12.5 25ZM14.0625 6.25C14.0625 5.8356 13.8979 5.43817 13.6049 5.14515C13.3118 4.85212 12.9144 4.6875 12.5 4.6875C12.0856 4.6875 11.6882 4.85212 11.3951 5.14515C11.1021 5.43817 10.9375 5.8356 10.9375 6.25V14.0625H16.6667C17.0811 14.0625 17.4785 13.8979 17.7715 13.6049C18.0645 13.3118 18.2292 12.9144 18.2292 12.5C18.2292 12.0856 18.0645 11.6882 17.7715 11.3951C17.4785 11.1021 17.0811 10.9375 16.6667 10.9375H14.0625V6.25Z" fill="#FFE870" />
                            </svg>
                            <p>Запланирована</p>
                            </div>
                        )
                    }
                    else if (statusGet == "возвращена") {
                        return (
                            <div onClick={handleOpenModal}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                <g clip-path="url(#clip0_1274_4166)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM7.12738 8.05497C7.12738 8.2969 7.27113 8.2448 7.47475 7.95891C8.78218 6.12339 10.8363 4.99967 13.043 5C16.903 5 20.0433 8.36463 20.0433 12.5003C20.0433 16.6357 16.903 20.0003 13.043 20C12.7206 20 12.4114 19.8628 12.1834 19.6185C11.9555 19.3743 11.8274 19.043 11.8274 18.6975C11.8274 18.3521 11.9555 18.0208 12.1834 17.7765C12.4114 17.5323 12.7206 17.395 13.043 17.395C15.5625 17.395 17.612 15.1991 17.612 12.5C17.612 9.80061 15.5625 7.60463 13.043 7.60463C11.4934 7.60463 10.0595 8.45385 9.22316 9.81722C9.03899 10.1178 9.10007 10.3838 9.31737 10.3838H9.71063C9.99274 10.3838 10.2633 10.5039 10.4628 10.7176C10.6623 10.9313 10.7743 11.2212 10.7743 11.5235C10.7743 11.8257 10.6623 12.1156 10.4628 12.3293C10.2633 12.5431 9.99274 12.6631 9.71063 12.6631H6.06369C5.78158 12.6631 5.51103 12.5431 5.31155 12.3293C5.11207 12.1156 5 11.8257 5 11.5235V7.61603C5 7.46637 5.02751 7.31817 5.08097 7.1799C5.13442 7.04163 5.21278 6.91599 5.31155 6.81016C5.41032 6.70433 5.52758 6.62039 5.65663 6.56311C5.78569 6.50584 5.92401 6.47636 6.06369 6.47636C6.20338 6.47636 6.3417 6.50584 6.47075 6.56311C6.5998 6.62039 6.71706 6.70433 6.81583 6.81016C6.91461 6.91599 6.99296 7.04163 7.04641 7.1799C7.09987 7.31817 7.12738 7.46637 7.12738 7.61603V8.05497Z" fill="#FC70FF" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1274_4166">
                                        <rect width="25" height="25" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <p>Возвращена</p>
                            </div>
                        )
                    }
                 })()}

                </div>
                 

                            <div id="myModal" class="modal" ref={modalRed} onClick={close}>

                            <div class="modal-content">
                                <span class="close" ref={spanRef}  onClick={handleCloseModal}>&times;</span>
                                {
                (() => {
                    if (getmyinfo.myinfo._id === allitemForStatus.creatorTasks) {
                        return (
                            <div class="dropdown-contentChangeStatus">
                                <div onClick={() => handleUpdateStatus("Принята")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                        <circle cx="13" cy="13" r="12.5" fill="#84FF70" />
                                        <rect x="6.97363" y="11.2776" width="8.80282" height="2.46479" transform="rotate(45 6.97363 11.2776)" fill="white" />
                                        <path d="M21.0254 9.6748L11.4558 19.2444L9.71289 17.5015L19.2825 7.93194L21.0254 9.6748Z" fill="white" />
                                    </svg>
                                    Принята
                                </div>
                                <div onClick={() => handleUpdateStatus("Отменено")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <path d="M12.5 0C5.59375 0 0 5.59375 0 12.5C0 19.4062 5.59375 25 12.5 25C19.4062 25 25 19.4062 25 12.5C25 5.59375 19.4062 0 12.5 0ZM19.1458 17.3125L17.3021 19.1562L12.5 14.3438L7.6875 19.1562L5.84375 17.3125L10.6562 12.5L5.85417 7.6875L7.69792 5.84375L12.5 10.6562L17.3125 5.84375L19.1562 7.6875L14.3438 12.5L19.1458 17.3125Z" fill="#FF7070" />
                                    </svg>
                                    Отменено
                                </div>
                                <div onClick={() => handleUpdateStatus("Выполняется")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4035 25 25 19.4035 25 12.5C25 5.59644 19.4035 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4035 5.59644 25 12.5 25Z" fill="#707EFF" />
                                        <path d="M16.7671 13.8238L10.8669 17.3073C9.91714 17.868 8.75 17.1381 8.75 15.9835V9.01645C8.75 7.86184 9.91714 7.13201 10.8669 7.69274L16.7671 11.1763C17.7443 11.7533 17.7443 13.2467 16.7671 13.8238Z" fill="white" />
                                    </svg>
                                    Выполняется
                                </div>
                                <div onClick={() => handleUpdateStatus("Выполнена")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <g clip-path="url(#clip0_1274_4128)">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4035 25 25 19.4035 25 12.5C25 5.59644 19.4035 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4035 5.59644 25 12.5 25Z" fill="#70DDFF" />
                                            <path d="M17.8495 8.53731C15.2966 6.69708 12.7441 10.276 10.1911 9.0313V8.76653C10.1911 8.43769 9.92435 8.17091 9.59554 8.17091C9.26674 8.17091 9 8.43769 9 8.76653V19.0186C9 19.3473 9.26674 19.6141 9.59554 19.6141C9.92435 19.6141 10.1911 19.3473 10.1911 19.0186V14.6754C12.6176 15.858 15.0442 12.6835 17.4711 13.9468C17.5262 13.9757 17.5878 13.9898 17.65 13.9879C17.7121 13.9859 17.7727 13.9679 17.8259 13.9355C17.8791 13.9033 17.9231 13.8579 17.9536 13.8037C17.9841 13.7495 18.0001 13.6883 18 13.6261V8.83085C17.9999 8.77351 17.9862 8.71702 17.96 8.66599C17.9339 8.61497 17.896 8.57087 17.8495 8.53731Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1274_4128">
                                                <rect width="25" height="25" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Выполнена
                                </div>
                                <div onClick={() => handleUpdateStatus("Запланирована")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C15.8152 25 18.9946 23.683 21.3388 21.3388C23.683 18.9946 25 15.8152 25 12.5C25 9.18479 23.683 6.00537 21.3388 3.66116C18.9946 1.31696 15.8152 0 12.5 0C9.18479 0 6.00537 1.31696 3.66116 3.66116C1.31696 6.00537 0 9.18479 0 12.5C0 15.8152 1.31696 18.9946 3.66116 21.3388C6.00537 23.683 9.18479 25 12.5 25ZM14.0625 6.25C14.0625 5.8356 13.8979 5.43817 13.6049 5.14515C13.3118 4.85212 12.9144 4.6875 12.5 4.6875C12.0856 4.6875 11.6882 4.85212 11.3951 5.14515C11.1021 5.43817 10.9375 5.8356 10.9375 6.25V14.0625H16.6667C17.0811 14.0625 17.4785 13.8979 17.7715 13.6049C18.0645 13.3118 18.2292 12.9144 18.2292 12.5C18.2292 12.0856 18.0645 11.6882 17.7715 11.3951C17.4785 11.1021 17.0811 10.9375 16.6667 10.9375H14.0625V6.25Z" fill="#FFE870" />
                                    </svg>
                                    Запланирована
                                </div>
                                <div onClick={() => handleUpdateStatus("возвращена")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <g clip-path="url(#clip0_1274_4166)">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM7.12738 8.05497C7.12738 8.2969 7.27113 8.2448 7.47475 7.95891C8.78218 6.12339 10.8363 4.99967 13.043 5C16.903 5 20.0433 8.36463 20.0433 12.5003C20.0433 16.6357 16.903 20.0003 13.043 20C12.7206 20 12.4114 19.8628 12.1834 19.6185C11.9555 19.3743 11.8274 19.043 11.8274 18.6975C11.8274 18.3521 11.9555 18.0208 12.1834 17.7765C12.4114 17.5323 12.7206 17.395 13.043 17.395C15.5625 17.395 17.612 15.1991 17.612 12.5C17.612 9.80061 15.5625 7.60463 13.043 7.60463C11.4934 7.60463 10.0595 8.45385 9.22316 9.81722C9.03899 10.1178 9.10007 10.3838 9.31737 10.3838H9.71063C9.99274 10.3838 10.2633 10.5039 10.4628 10.7176C10.6623 10.9313 10.7743 11.2212 10.7743 11.5235C10.7743 11.8257 10.6623 12.1156 10.4628 12.3293C10.2633 12.5431 9.99274 12.6631 9.71063 12.6631H6.06369C5.78158 12.6631 5.51103 12.5431 5.31155 12.3293C5.11207 12.1156 5 11.8257 5 11.5235V7.61603C5 7.46637 5.02751 7.31817 5.08097 7.1799C5.13442 7.04163 5.21278 6.91599 5.31155 6.81016C5.41032 6.70433 5.52758 6.62039 5.65663 6.56311C5.78569 6.50584 5.92401 6.47636 6.06369 6.47636C6.20338 6.47636 6.3417 6.50584 6.47075 6.56311C6.5998 6.62039 6.71706 6.70433 6.81583 6.81016C6.91461 6.91599 6.99296 7.04163 7.04641 7.1799C7.09987 7.31817 7.12738 7.46637 7.12738 7.61603V8.05497Z" fill="#FC70FF" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1274_4166">
                                                <rect width="25" height="25" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Возвращена
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div class="dropdown-contentChangeStatus">
                                <div style={{opacity:"0.6"}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                                        <circle cx="13" cy="13" r="12.5" fill="#84FF70" />
                                        <rect x="6.97363" y="11.2776" width="8.80282" height="2.46479" transform="rotate(45 6.97363 11.2776)" fill="white" />
                                        <path d="M21.0254 9.6748L11.4558 19.2444L9.71289 17.5015L19.2825 7.93194L21.0254 9.6748Z" fill="white" />
                                    </svg>
                                    Принята
                                </div>
                                <div style={{opacity:"0.6"}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <path d="M12.5 0C5.59375 0 0 5.59375 0 12.5C0 19.4062 5.59375 25 12.5 25C19.4062 25 25 19.4062 25 12.5C25 5.59375 19.4062 0 12.5 0ZM19.1458 17.3125L17.3021 19.1562L12.5 14.3438L7.6875 19.1562L5.84375 17.3125L10.6562 12.5L5.85417 7.6875L7.69792 5.84375L12.5 10.6562L17.3125 5.84375L19.1562 7.6875L14.3438 12.5L19.1458 17.3125Z" fill="#FF7070" />
                                    </svg>
                                    Отменено
                                </div>
                                <div onClick={() => handleStatusAndSendNotify("Выполняется")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4035 25 25 19.4035 25 12.5C25 5.59644 19.4035 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4035 5.59644 25 12.5 25Z" fill="#707EFF" />
                                        <path d="M16.7671 13.8238L10.8669 17.3073C9.91714 17.868 8.75 17.1381 8.75 15.9835V9.01645C8.75 7.86184 9.91714 7.13201 10.8669 7.69274L16.7671 11.1763C17.7443 11.7533 17.7443 13.2467 16.7671 13.8238Z" fill="white" />
                                    </svg>
                                    Выполняется
                                </div>
                                <div onClick={() => [handleUpdateStatus("Выполнена"),handleStatus()]}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <g clip-path="url(#clip0_1274_4128)">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4035 25 25 19.4035 25 12.5C25 5.59644 19.4035 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4035 5.59644 25 12.5 25Z" fill="#70DDFF" />
                                            <path d="M17.8495 8.53731C15.2966 6.69708 12.7441 10.276 10.1911 9.0313V8.76653C10.1911 8.43769 9.92435 8.17091 9.59554 8.17091C9.26674 8.17091 9 8.43769 9 8.76653V19.0186C9 19.3473 9.26674 19.6141 9.59554 19.6141C9.92435 19.6141 10.1911 19.3473 10.1911 19.0186V14.6754C12.6176 15.858 15.0442 12.6835 17.4711 13.9468C17.5262 13.9757 17.5878 13.9898 17.65 13.9879C17.7121 13.9859 17.7727 13.9679 17.8259 13.9355C17.8791 13.9033 17.9231 13.8579 17.9536 13.8037C17.9841 13.7495 18.0001 13.6883 18 13.6261V8.83085C17.9999 8.77351 17.9862 8.71702 17.96 8.66599C17.9339 8.61497 17.896 8.57087 17.8495 8.53731Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1274_4128">
                                                <rect width="25" height="25" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Выполнена
                                </div>
                                <div onClick={() => handleUpdateStatus("Запланирована")}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C15.8152 25 18.9946 23.683 21.3388 21.3388C23.683 18.9946 25 15.8152 25 12.5C25 9.18479 23.683 6.00537 21.3388 3.66116C18.9946 1.31696 15.8152 0 12.5 0C9.18479 0 6.00537 1.31696 3.66116 3.66116C1.31696 6.00537 0 9.18479 0 12.5C0 15.8152 1.31696 18.9946 3.66116 21.3388C6.00537 23.683 9.18479 25 12.5 25ZM14.0625 6.25C14.0625 5.8356 13.8979 5.43817 13.6049 5.14515C13.3118 4.85212 12.9144 4.6875 12.5 4.6875C12.0856 4.6875 11.6882 4.85212 11.3951 5.14515C11.1021 5.43817 10.9375 5.8356 10.9375 6.25V14.0625H16.6667C17.0811 14.0625 17.4785 13.8979 17.7715 13.6049C18.0645 13.3118 18.2292 12.9144 18.2292 12.5C18.2292 12.0856 18.0645 11.6882 17.7715 11.3951C17.4785 11.1021 17.0811 10.9375 16.6667 10.9375H14.0625V6.25Z" fill="#FFE870" />
                                    </svg>
                                    Запланирована
                                </div>
                                <div style={{opacity:"0.6"}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                        <g clip-path="url(#clip0_1274_4166)">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM7.12738 8.05497C7.12738 8.2969 7.27113 8.2448 7.47475 7.95891C8.78218 6.12339 10.8363 4.99967 13.043 5C16.903 5 20.0433 8.36463 20.0433 12.5003C20.0433 16.6357 16.903 20.0003 13.043 20C12.7206 20 12.4114 19.8628 12.1834 19.6185C11.9555 19.3743 11.8274 19.043 11.8274 18.6975C11.8274 18.3521 11.9555 18.0208 12.1834 17.7765C12.4114 17.5323 12.7206 17.395 13.043 17.395C15.5625 17.395 17.612 15.1991 17.612 12.5C17.612 9.80061 15.5625 7.60463 13.043 7.60463C11.4934 7.60463 10.0595 8.45385 9.22316 9.81722C9.03899 10.1178 9.10007 10.3838 9.31737 10.3838H9.71063C9.99274 10.3838 10.2633 10.5039 10.4628 10.7176C10.6623 10.9313 10.7743 11.2212 10.7743 11.5235C10.7743 11.8257 10.6623 12.1156 10.4628 12.3293C10.2633 12.5431 9.99274 12.6631 9.71063 12.6631H6.06369C5.78158 12.6631 5.51103 12.5431 5.31155 12.3293C5.11207 12.1156 5 11.8257 5 11.5235V7.61603C5 7.46637 5.02751 7.31817 5.08097 7.1799C5.13442 7.04163 5.21278 6.91599 5.31155 6.81016C5.41032 6.70433 5.52758 6.62039 5.65663 6.56311C5.78569 6.50584 5.92401 6.47636 6.06369 6.47636C6.20338 6.47636 6.3417 6.50584 6.47075 6.56311C6.5998 6.62039 6.71706 6.70433 6.81583 6.81016C6.91461 6.91599 6.99296 7.04163 7.04641 7.1799C7.09987 7.31817 7.12738 7.46637 7.12738 7.61603V8.05497Z" fill="#FC70FF" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1274_4166">
                                                <rect width="25" height="25" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    Возвращена
                                </div>
                            </div>
                        )
                    }
                })()
            }
                            </div>

                            </div>
        </div>
    );
};

export default DropdownMobileStatus;
